// Image asset names
export const IMAGE_ASSETS = [
    // Floor textures
    'environment/floors/bones.png',
    'environment/floors/clouds.png',
    'environment/floors/crackedseaice.png',
    'environment/floors/crag.png',
    'environment/floors/desert.png',
    'environment/floors/dirt.png',
    'environment/floors/dirtpatch.png',
    'environment/floors/grass.png',
    'environment/floors/gravel.png',
    'environment/floors/housetile.png',
    'environment/floors/mulch.png',
    'environment/floors/seaice.png',
    'environment/floors/underbrush.png',
    'environment/floors/aqua.png',
    'environment/floors/museum_floor_1.png',
    'environment/floors/museum_floor_2.png',
    'environment/floors/museum_floor_dark_1.png',
    'environment/floors/museum_floor_dark_2.png',
    'environment/floors/white_mus_floor_1.png',
    'environment/floors/white_mus_floor_2.png',
    // Wall textures
    'environment/walls/rockwall.png',
    'environment/walls/museumwall.png',
    'environment/walls/museumwall1.png',
    'environment/walls/museumwall2.png',
    'environment/walls/museumwall4.png',
    'environment/walls/museumwall5.png',
    'environment/walls/museumwall6.png',
    'environment/walls/90s.png',
    'environment/walls/astrocrag.png',
    'environment/trim/bordertrim.png',
    'environment/walls/chargedwall.png',
    'environment/walls/cobble.png',
    'environment/walls/coralwall.png',
    'environment/walls/deco.png',
    'environment/walls/fortwall.png',
    'environment/walls/heartstone.png',
    'environment/walls/lavawall.png',
    'environment/walls/zydeco.png',
    'environment/walls/white_mus_exterior/white_mus_wall_0.png',
    'environment/walls/white_mus_exterior/white_mus_wall_1.png',
    'environment/walls/white_mus_exterior/white_mus_wall_2.png',
    'environment/walls/white_mus_exterior/white_mus_wall_3.png',
    'environment/walls/white_mus_exterior/white_mus_wall_4.png',
    'environment/walls/white_mus_exterior/white_mus_wall_5.png',
    'environment/walls/white_mus_exterior/white_mus_wall_6.png',
    'environment/walls/white_mus_exterior/white_mus_wall_8.png',
    'environment/walls/white_mus_exterior/white_mus_wall_9.png',
    'environment/walls/white_mus_exterior/white_mus_wall_10.png',
    'environment/walls/white_mus_exterior/white_mus_wall_11.png',
    'environment/walls/white_mus_exterior/white_mus_wall_12.png',
    'environment/walls/white_mus_exterior/white_mus_wall_13.png',
    'environment/walls/white_mus_exterior/white_mus_wall_14.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_0.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_1.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_2.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_3.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_4.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_5.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_6.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_7.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_8.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_9.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_10.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_11.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_12.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_13.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_14.png',
    'environment/walls/black_mus_exterior/black_mus_exterior_tile_15.png',
    'environment/obstacles/rock.png',
    'environment/obstacles/shrubbery.png',
    'environment/walls/bush.png',
    'environment/doodads/anemone.png',
    'environment/doodads/big_tree.png',
    'environment/doodads/blue_shroom.png',
    'environment/doodads/cactus.png',
    'environment/doodads/cactus2.png',
    'environment/doodads/museum.png',
    'environment/doodads/cube.png',
    'environment/doodads/green_shroom.png',
    'environment/doodads/small_evergreen.png',
    'environment/doodads/table.png',
    'environment/doodads/urchin.png',
    'items/consumables/water.png',
    'environment/doodads/shack.png',
    'characters/player/Special2.png',
    'environment/doodads/grate.png',
    'characters/player/whack.png',
    'characters/player/dead.png',
    'characters/enemies/lizardy.png',
    'characters/enemies/lizardo.png',
    'characters/enemies/lizardeaux.png',
    'characters/enemies/lizord.png',
    'characters/enemies/lazerd.png',
    'items/equipment/axe.png',
    'items/equipment/hammer.png',
    'items/equipment/spear.png',
    'items/misc/bomb.png',
    'items/misc/heart.png',
    'items/misc/note.png',
    'items/misc/book.png',
    'items/misc/branch.png',
    'items/equipment/bow.png',
    'environment/doodads/stairdown.png',
    // Use the actual stairup filename present in the repo; TextureLoader will accept both names
    'environment/doodads/stairup.png',
    'items/equipment/shovel.png',
    'items/misc/points.png',
    'items/misc/chest.png',
    'environment/doodads/well.png',
    'environment/doodads/hole.png',
    'environment/doodads/deadtree.png',
    'environment/doodads/pitfall.png',
    // Merchant NPCs
    'characters/npcs/merchant/penne.png',
    'characters/npcs/merchant/squig.png',
    'characters/npcs/merchant/nib.png',
    'characters/npcs/merchant/rune.png',
    'characters/npcs/merchant/mark.png',
    'characters/npcs/merchant/gouge.png',
    'characters/npcs/merchant/axolotl.png',
    // Tutorial NPCs
    'characters/npcs/tutorial/crayn.png',
    'characters/npcs/tutorial/felt.png',
    'characters/npcs/tutorial/forge.png',
    // NPC Portraits
    'characters/npcs/portraits/asterface.png',
    'characters/npcs/portraits/axolotlface.png',
    'characters/npcs/portraits/blotface.png',
    'characters/npcs/portraits/blotterface.png',
    'characters/npcs/portraits/brushface.png',
    'characters/npcs/portraits/burinface.png',
    'characters/npcs/portraits/calamusface.png',
    'characters/npcs/portraits/capface.png',
    'characters/npcs/portraits/cinnabarface.png',
    'characters/npcs/portraits/craynface.png',
    'characters/npcs/portraits/crockface.png',
    'characters/npcs/portraits/feltface.png',
    'characters/npcs/portraits/filumface.png',
    'characters/npcs/portraits/forgeface.png',
    'characters/npcs/portraits/forkface.png',
    'characters/npcs/portraits/gelface.png',
    'characters/npcs/portraits/gouacheface.png',
    'characters/npcs/portraits/gougeface.png',
    'characters/npcs/portraits/haneface.png',
    'characters/npcs/portraits/kraftface.png',
    'characters/npcs/portraits/markface.png',
    'characters/npcs/portraits/merkiface.png',
    'characters/npcs/portraits/micronface.png',
    'characters/npcs/portraits/nibface.png',
    'characters/npcs/portraits/penneface.png',
    'characters/npcs/portraits/penniface.png',
    'characters/npcs/portraits/plumaface.png',
    'characters/npcs/portraits/plumeface.png',
    'characters/npcs/portraits/quillface.png',
    'characters/npcs/portraits/raddleface.png',
    'characters/npcs/portraits/runeface.png',
    'characters/npcs/portraits/scritchface.png',
    'characters/npcs/portraits/silverface.png',
    'characters/npcs/portraits/sineface.png',
    'characters/npcs/portraits/slateface.png',
    'characters/npcs/portraits/slickface.png',
    'characters/npcs/portraits/slugface.png',
    'characters/npcs/portraits/squigface.png',
    'characters/npcs/portraits/styletface.png',
    'characters/npcs/portraits/vellumface.png',
    // New gossip NPC portraits
    'characters/npcs/portraits/bitface.png',
    'characters/npcs/portraits/blockface.png',
    'characters/npcs/portraits/calliface.png',
    'characters/npcs/portraits/capybaraface.png',
    'characters/npcs/portraits/flexface.png',
    'characters/npcs/portraits/gelinkaface.png',
    'characters/npcs/portraits/gomaface.png',
    'characters/npcs/portraits/highlightface.png',
    'characters/npcs/portraits/hojaface.png',
    'characters/npcs/portraits/midoriface.png',
    'characters/npcs/portraits/nubface.png',
    'characters/npcs/portraits/pollyface.png',
    'characters/npcs/portraits/pulpface.png',
    'characters/npcs/portraits/redaktface.png',
    'characters/npcs/portraits/scrapeface.png',
    'characters/npcs/portraits/scrollface.png',
    'characters/npcs/portraits/shadeface.png',
    'characters/npcs/portraits/skribface.png',
    'characters/npcs/portraits/stickface.png',
    'characters/npcs/portraits/washface.png',
    // New gossip NPC portraits (added 2025-11-11)
    'characters/npcs/portraits/bladderface.png',
    'characters/npcs/portraits/bulletface.png',
    'characters/npcs/portraits/cartoucheface.png',
    'characters/npcs/portraits/coursierface.png',
    'characters/npcs/portraits/cretaface.png',
    'characters/npcs/portraits/dashface.png',
    'characters/npcs/portraits/dinkusface.png',
    'characters/npcs/portraits/emface.png',
    'characters/npcs/portraits/fasciaface.png',
    'characters/npcs/portraits/fascinusface.png',
    'characters/npcs/portraits/fontface.png',
    'characters/npcs/portraits/fudeface.png',
    'characters/npcs/portraits/grawlixface.png',
    'characters/npcs/portraits/kajiface.png',
    'characters/npcs/portraits/lupiface.png',
    'characters/npcs/portraits/palimpsestface.png',
    'characters/npcs/portraits/puntoface.png',
    'characters/npcs/portraits/spectrumface.png',
    'characters/npcs/portraits/spitzeface.png',
    'characters/npcs/portraits/Yface.png',
    // Gossip NPCs
    'characters/npcs/gossip/aster.png',
    'characters/npcs/gossip/blot.png',
    'characters/npcs/gossip/blotter.png',
    'characters/npcs/gossip/brush.png',
    'characters/npcs/gossip/burin.png',
    'characters/npcs/gossip/calamus.png',
    'characters/npcs/gossip/cap.png',
    'characters/npcs/gossip/cinnabar.png',
    'characters/npcs/gossip/crock.png',
    'characters/npcs/gossip/dragon.png',
    'characters/npcs/gossip/filum.png',
    'characters/npcs/gossip/fork.png',
    'characters/npcs/gossip/gel.png',
    'characters/npcs/gossip/gouache.png',
    'characters/npcs/gossip/hane.png',
    'characters/npcs/gossip/kraft.png',
    'characters/npcs/gossip/merki.png',
    'characters/npcs/gossip/micron.png',
    'characters/npcs/gossip/penni.png',
    'characters/npcs/gossip/pluma.png',
    'characters/npcs/gossip/plume.png',
    'characters/npcs/gossip/quill.png',
    'characters/npcs/gossip/raddle.png',
    'characters/npcs/gossip/scritch.png',
    'characters/npcs/gossip/silver.png',
    'characters/npcs/gossip/sine.png',
    'characters/npcs/gossip/slate.png',
    'characters/npcs/gossip/slick.png',
    'characters/npcs/gossip/slug.png',
    'characters/npcs/gossip/snak.png',
    'characters/npcs/gossip/stylet.png',
    'characters/npcs/gossip/vellum.png',
    // New gossip NPCs
    'characters/npcs/gossip/bit.png',
    'characters/npcs/gossip/block.png',
    'characters/npcs/gossip/calli.png',
    'characters/npcs/gossip/capybara.png',
    'characters/npcs/gossip/flex.png',
    'characters/npcs/gossip/gelinka.png',
    'characters/npcs/gossip/goma.png',
    'characters/npcs/gossip/highlight.png',
    'characters/npcs/gossip/hoja.png',
    'characters/npcs/gossip/midori.png',
    'characters/npcs/gossip/nub.png',
    'characters/npcs/gossip/polly.png',
    'characters/npcs/gossip/pulp.png',
    'characters/npcs/gossip/redakt.png',
    'characters/npcs/gossip/scrape.png',
    'characters/npcs/gossip/scroll.png',
    'characters/npcs/gossip/shade.png',
    'characters/npcs/gossip/skrib.png',
    'characters/npcs/gossip/stick.png',
    'characters/npcs/gossip/wash.png',
    // New gossip NPCs (added 2025-11-11)
    'characters/npcs/gossip/bladder.png',
    'characters/npcs/gossip/bullet.png',
    'characters/npcs/gossip/cartouche.png',
    'characters/npcs/gossip/coursier.png',
    'characters/npcs/gossip/creta.png',
    'characters/npcs/gossip/dash.png',
    'characters/npcs/gossip/dinkus.png',
    'characters/npcs/gossip/em.png',
    'characters/npcs/gossip/fascia.png',
    'characters/npcs/gossip/fascinus.png',
    'characters/npcs/gossip/font.png',
    'characters/npcs/gossip/fude.png',
    'characters/npcs/gossip/grawlix.png',
    'characters/npcs/gossip/kaji.png',
    'characters/npcs/gossip/lupi.png',
    'characters/npcs/gossip/palimpsest.png',
    'characters/npcs/gossip/punto.png',
    'characters/npcs/gossip/spectrum.png',
    'characters/npcs/gossip/spitze.png',
    'characters/npcs/gossip/y.png',
    'characters/enemies/zard.png',
    'environment/floors/desert.png',
    'environment/walls/succulent.png',
    'environment/walls/stump.png',
    'environment/walls/blocklily.png',
    'environment/walls/boulder.png',
    'environment/doodads/sign.png',
    'environment/doodads/sign-blank.png',
    'environment/doodads/sign-eaten.png',
    'environment/doodads/sign-gold.png',
    'environment/doodads/sign-metal.png',
    'environment/doodads/sign-metal-alt.png',
    'items/misc/horse.png',
    'characters/player/default.png',
    'characters/player/faceset.png',
    'items/misc/arrow.png',
    'environment/floors/housetile.png',
    'ui/arrow.png',
    'ui/pawn_white.png',
    'ui/knight_black.png',
    'environment/effects/smoke_frame_1.png',
    'environment/effects/smoke_frame_2.png',
    'environment/effects/smoke_frame_3.png',
    'environment/effects/smoke_frame_4.png',
    'environment/effects/smoke_frame_5.png',
    'environment/effects/smoke_frame_6.png',
    'environment/effects/splode_1.png',
    'environment/effects/splode_2.png',
    'environment/effects/splode_3.png',
    'environment/effects/splode_4.png',
    'environment/effects/splode_5.png',
    'environment/effects/splode_6.png',
    'environment/effects/splode_7.png',
    'environment/effects/splode_8.png',
    'environment/effects/fog.png'
] as const;

export type ImageAsset = typeof IMAGE_ASSETS[number];

// Food image assets
export const FOOD_ASSETS = [
    'items/consumables/meat.png',
    'items/consumables/nut.png',
    'items/consumables/aguamelin.png'
] as const;

export type FoodAsset = typeof FOOD_ASSETS[number];

export const TOTAL_IMAGES = IMAGE_ASSETS.length + FOOD_ASSETS.length;
